<template>
    <v-container fluid  align-content-center justify-start class="loginOverlay">
        <v-layout wrap align-center justify-center>
            <v-flex xs12 sm12 md12 style="text-align: center" class="mt-3">
              <img src="@/assets/lpn_default_350px.png" style="width: 180px"/>
            </v-flex>
            <div class="flex xs12 md12 sm12"><h1 class="mt-3 text-xs-center display-1 font-weight-bold">Service Excellence</h1></div>
            <v-flex xs12 sm4 md4 class="mt-4">
                <v-card class="card-border">
                    <v-card-title></v-card-title>
                    <v-card-text class="pt-2">
                        <div>

                            <v-alert v-if="error.status==='0'" class="mt-1 mb-4"
                                     :value="true"
                                     color="error"
                                     icon="warning"
                                     outline
                            >
                                <span>{{ error.msg }}</span>
                            </v-alert>

                            <v-form v-model="valid" ref="form">
                                <!--<p class="blue-grey&#45;&#45;text font-weight-bold">ชื่อผู้ใช้งาน</p>-->
                                <v-text-field
                                        label="ชื่อผู้ใช้งาน"
                                        v-model="user_data.username"
                                        :rules="usernameRules"
                                        required
                                        placeholder="Username"
                                        @keypress.enter="loginUser()"
                                ></v-text-field>

                                <!--<p class="blue-grey&#45;&#45;text font-weight-bold">รหัสผ่าน</p>-->
                                <v-text-field
                                        label="รหัสผ่าน"
                                        v-model="user_data.password"
                                        :type="e1 ? 'text' : 'password'"
                                        :rules="passwordRules"
                                        required
                                        placeholder="Password"
                                        @keypress.enter="loginUser()"
                                ></v-text-field>
                                <v-layout justify-space-between class="mt-2">
                                    <v-btn @click="loginUser" :class="valid ? 'blue darken-4 white--text':'grey white--text'" :disabled="!valid">ล๊อคอิน</v-btn>
                                    <a href="https://selfservice.lpn.co.th:8888">ลืมรหัสผ่าน?</a>
                                </v-layout>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import axios_auth from '@/axios_auth'
    import axios_lpp from "@/axios_lpp";
    import EventBus from '@/EventBus'

    export default {
        name: "Login",
        data(){
            return {
                valid: false,
                e1: false,
                user_data: {
                    username:'',
                    password: '',
                    system:'SVEA_EMP'
                },
                passwordRules: [
                    (v) => !!v || 'กรุณากรอกรหัสผ่าน',
                ],
                usernameRules: [
                    (v) => !!v || 'กรุณากรอกชื่อผู้ใช้งาน',
                ],
                error: {
                    status:1,
                    error_code:'401',
                    msg:''
                },
                user_lpnis:{
                    username:'',
                    system_key:'0C1704F649384EF9B979434D26A1C56C'
                },
                ss:'',
                routeUrl: "home",
            }

        },
        mounted(){
            // console.log("start",this.ss)
            // console.log("key",this.$route.query.key)
            // console.log("route",this.$route.query.u)
            if(this.$route.query.key&&this.$route.query.u) {
                this.user_lpnis.username = this.$route.query.u
                this.ss = window.btoa(this.user_lpnis.username + 'lpnSvEa'+new Date().getDate())
                // console.log("in",this.ss)
                if(this.ss==this.$route.query.key){

                  if((this.$route.query.ru) && (this.$route.query.ru != '')){
                    this.routeUrl = this.$route.query.ru;
                  }

                    this.logout()
                    this.lpnisLogin()
                }else{
                  this.error.status = '0';
                  this.error.error_code = 'error'
                  this.error.msg = 'ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง';
                }
            }

            let localitem = this.getLocalItem()
            if (localitem) {
                if (localitem.availableUntil) {
                    if (this.$moment().diff(localitem.availableUntil, 'second') < 0) {
                        return this.$router.replace({name: this.routeUrl})
                    }
                }
            }
        },
        methods: {
            async loginUser()
            {
                try{

                    axios_lpp.post('SecureApi/Authentication', JSON.stringify(this.user_data))
                        .then(res => {
                            if(res.data.status==="1") {
                                //set user token to localStorage
                                let auth_data = {
                                    'refreshToken': res.data.refreshToken,
                                    'token': res.data.jwt,
                                    'user_id': this.user_data.username
                                }
                                localStorage.setItem('svea_emp', JSON.stringify(auth_data))
                            }

                        }).then(() => {
                            this.refreshToken().then((res)=>{
                                let auth_data = {
                                    'refreshToken': res.refreshToken,
                                    'token': res.jwt,
                                    'user_id': this.user_data.username,
                                    'availableUntil': res.availableUntil
                                }
                                localStorage.setItem('svea_emp', JSON.stringify(auth_data))

                                EventBus.$emit('setToken', {token:res.jwt})

                                if(this.routeUrl == ''){
                                  this.routeUrl = "home";
                                }

                                this.$router.replace({name: this.routeUrl})
                            })
                        })
                        .catch(err => {
                            if (err.response) {
                                this.error.status = err.response.data.status
                                this.error.error_code = err.response.status
                                if(err.response.status===401){
                                    this.error.msg = "ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง"
                                }else{
                                    this.error.msg = err.response.data.msg
                                }

                                console.log(this.error)
                            }
                        })
                }catch(err2)
                {
                    console.log(err2.message)
                }
            },
            async lpnisLogin()
            {
                // console.log("lpn login")
                try{

                  //เปลี่ยนไปใช้ของเชิฟเวอร์ LPP เพื่อทดสอบว่าลดโหลด
                  //axios_auth.post('AuthenticationByKey', JSON.stringify(this.user_lpnis))
                  axios_lpp.post('SecureApi/AuthenticationByKey', JSON.stringify(this.user_lpnis))
                        .then(res => {

                            if(res.data.status==="1") {
                                //set user token to localStorage
                                let auth_data = {
                                    'refreshToken': res.data.refreshToken,
                                    'token': res.data.jwt,
                                    'user_id': this.user_lpnis.username
                                }
                                localStorage.setItem('svea_emp', JSON.stringify(auth_data))
                            }else{

                              alert(res.data.msg);
                              this.$router.replace('/login');
                              return false;
                            }

                        }).then(() => {

                        this.refreshToken().then((res)=>{

                          if(res.status==="1") {

                            let auth_data = {
                              'refreshToken': res.refreshToken,
                              'token': res.jwt,
                              'user_id': this.user_lpnis.username,
                              'availableUntil': res.availableUntil
                            }
                            localStorage.setItem('svea_emp', JSON.stringify(auth_data))

                            EventBus.$emit('setToken', {token: res.jwt})

                            //this.$router.replace({name:'evaluate'})
                            this.$router.replace({name: this.routeUrl})
                          }else{
                            alert(res.msg);
                            this.$router.replace('/login');
                            return false;
                          }

                        })

                    })
                        .catch(err => {

                            if (err.response) {
                                this.error.status = err.response.data.status
                                this.error.error_code = err.response.status
                                if(err.response.status===401){
                                    this.error.msg = "ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง"
                                }else{
                                    this.error.msg = err.response.data.msg
                                }

                                console.log(this.error)
                            }
                        })
                }catch(err2)
                {
                    console.log(err2.message)

                }
            }
        }
    }
</script>

<style scoped>
    .loginOverlay{
        background: #fff;
    }
    .card-border{
        border-radius: 10px;
    }
    /*.v-messages__message{*/
        /*line-height:1.5 !important;*/
    /*}*/
</style>